/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Attachments_LabelInputs */

const en_settings_tickets_attachments_label = /** @type {(inputs: Settings_Tickets_Attachments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images (optional)`)
};

/**
* | output |
* | --- |
* | "Images (optional)" |
*
* @param {Settings_Tickets_Attachments_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_attachments_label = /** @type {((inputs?: Settings_Tickets_Attachments_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Attachments_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_attachments_label(inputs)
});
export { settings_tickets_attachments_label as "settings.tickets.attachments_label" }